import { render, staticRenderFns } from "./CalendarForm.vue?vue&type=template&id=0fbb3650&"
import script from "./CalendarForm.vue?vue&type=script&lang=js&"
export * from "./CalendarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports